import fetch from '../../../core/fetch';
import { closeListSettingsModal } from '../../../actions/siteadmin/modalActions';
import { getAdminListingSettings } from '../../../actions/siteadmin/getAdminListingSettings';
import showToaster from '../../../helpers/showToaster';
import { updateListSettings as query } from '../../../lib/graphql';

async function update(values, dispatch, currentPage) {
  let startValue = Number(values?.startValue), endValue = Number(values?.endValue);
  let variables = Object.assign({}, values, { startValue, endValue });

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.updateListSettings?.status === "success") {
    dispatch(closeListSettingsModal());
    await dispatch(getAdminListingSettings(values.typeId, currentPage));
    showToaster({ messageId: 'updateListSettings', toasterType: 'success' })
  } else if (data?.updateListSettings?.status === "unableToDisable") {
    showToaster({ messageId: 'disableListSettings', toasterType: 'error' })
  } else if (data?.updateListSettings?.status === "listingUsed") {
    showToaster({ messageId: 'listingUsed', toasterType: 'error' })
  } else {
    showToaster({ messageId: 'commonError', toasterType: 'error' })
  }
}

export default update;
